const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://your-api-endpoint.com/api';

export const loadContent = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/content`);
    if (response.ok) {
      return await response.json();
    }
    console.warn('Failed to load content from API, using defaults');
    return {};
  } catch (error) {
    console.warn('API not available, using default content:', error.message);
    return {};
  }
};

export const saveContent = async (sectionId, content) => {
  try {
    const response = await fetch(`${API_BASE_URL}/content/${sectionId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${process.env.REACT_APP_API_TOKEN || ''}`
      },
      body: JSON.stringify({ content })
    });
    
    if (!response.ok) {
      throw new Error(`Failed to save content: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Failed to save content:', error.message);
    localStorage.setItem(`content_${sectionId}`, content);
    console.log('Content saved to localStorage as fallback');
  }
};

export const loadContentFromLocalStorage = () => {
  const content = {};
  const keys = Object.keys(localStorage).filter(key => key.startsWith('content_'));
  
  keys.forEach(key => {
    const sectionId = key.replace('content_', '');
    content[sectionId] = localStorage.getItem(key);
  });
  
  return content;
};